<template>
  <div>
    <div class="header"></div>
    <div class="logo-box w">
      <!-- logo S -->
      <div class="logo fl">
        <router-link to="/" style="display: block">
          www.rakumart-2c.com
        </router-link>
      </div>
      <div class="fl fenge"></div>
      <h2 class="fl">新規会員登録</h2>
      <div class="login fr">
        　　ログインへ <span>登録済み</span>&nbsp;&nbsp;
        <router-link to="/login">ログインへ？</router-link>
      </div>
      <!-- logo E -->
    </div>
    <div class="register w">
      <el-form :model="formregister" :rules="formRules" ref="formRef">
        <ul>
          <li>
            <el-form-item prop="user" label="ユーザー名:" label-width="150px">
              <el-input class="ipt" placeholder="ユーザー名を入力してください" v-model="formregister.user"></el-input>
            </el-form-item>
          </li>
          <li>
            <el-form-item prop="name" label="氏名:" label-width="150px">
              <el-input class="ipt" placeholder="氏名を入力してください" v-model="formregister.name"></el-input>
              <span>（漢字推奨）</span>
            </el-form-item>
          </li>
          <li>
            <el-form-item prop="chatwork" label="chatwork ID:" label-width="150px">
              <el-input class="ipt" placeholder="chatwork ID" v-model="formregister.chatwork"></el-input>
              <span>
                <a :href="`https://www.chatwork.com/RAKUMART-CS`" target="_blank">
                  <img src="../../assets/img/cw图标_u198.e798d694.svg" alt="" /></a>

                お持ちでない場合は新規作成をお願いします</span>
            </el-form-item>
          </li>
          <li>
            <el-form-item prop="email" label="メールアドレス:" label-width="150px">
              <el-input class="ipt" placeholder="メールアドレスを入力してください" v-model="formregister.email"></el-input>
            </el-form-item>
          </li>
          <li>
            <el-form-item prop="phone" label="電話番号:" label-width="150px">
              <el-input class="ipt" placeholder="日本国内の携帯電話番号を入力してください" v-model="formregister.phone"></el-input>
            </el-form-item>
          </li>

          <li class="yanzhengma">
            <el-form-item label="コード:" label-width="150px" prop="num">
              <el-button size="mini" type="success" @click="sendSMS" v-show="show">確認コードを取得</el-button>
              <el-button v-show="!show" size="mini">{{ Countdown }}重新发送</el-button>
              <el-input v-model="formregister.num" class="input"></el-input>
            </el-form-item>
          </li>
          <li>
            <el-form-item prop="password" label="パスワード:" label-width="150px">
              <el-input class="ipt" v-model="formregister.password" type="password"></el-input>
            </el-form-item>
          </li>
          <li>
            <el-form-item prop="repassword" label="パスワード再確認:" label-width="150px">
              <el-input class="ipt" v-model="formregister.confirmpassword" type="password"></el-input>
            </el-form-item>
          </li>
          <li>
            <el-form-item style="margin-left: 150px" class="xieyi">
              <input type="checkbox" @change="agreement = !agreement" />

              <router-link to="/guiyue">Rakumart利用規約＆プライバシーポリシー</router-link>
            </el-form-item>
          </li>
          <li>
            <p>
              ※確認コード取得ボタンを押しても、携帯SMSに送信されない場合は、問い合わせよりご連絡ください。
            </p>
          </li>
          <li>
            <a href="javascript:;" class="btn" @click="formRegister" style="margin-left: 150px">登録</a>
          </li>
        </ul>
      </el-form>
    </div>
    <Foot></Foot>
  </div>
</template>
<script>
import Foot from "../../components/foot/Foot";
import * as sysTool from "../../assets/js/systemTool";
import { formRegister, sendSMS, checkRegisterField } from "../../api/API/login";
import getUserIP from "../../utlis/utlis";
// import { gtag_report_conversion } from "../../utlis/guge";
export default {
  data() {
    // 字段验证 用户名
    var ddusernameFieldValidation = (rule, value, callback) => {
      let datas = {
        field: 'ddusername',
        value,
      }
      checkRegisterField(datas).then(res => {
        if (res.code != 1) {
          callback(new Error("ユーザー名が既に利用されています"));
        } else {
          callback();
        }
      })

    }
    // 字段验证 手机号
    var phoneFieldValidation = (rule, value, callback) => {
      let datas = {
        field: 'mobile',
        value,
      }
      checkRegisterField(datas).then(res => {
        if (res.code != 1) {
          callback(new Error("こちらの携帯番号既に登録済みです"));
        } else {
          callback();
        }
      })

    }
    // 字段验证 邮箱
    var emailFieldValidation = (rule, value, callback) => {
      let datas = {
        field: 'email',
        value,
      }
      checkRegisterField(datas).then(res => {
        if (res.code != 1) {
          callback(new Error("メールアドレスが既に登録済みです "));
        } else {
          callback();
        }
      })

    }
    // var new_password = (rule, value, callback) => {
    //   if (this.formregister.passwprd === "") {
    //     callback(new Error("请输入密码"));
    //   } else {
    //     if (this.formregister.passwprd !== "") {
    //       this.$refs.formRef.validateField("userPassWord");
    //     }
    //     callback();
    //   }
    // };
    var userPassWord = (rule, value, callback) => {
      if (this.formregister.confirmpassword === "") {
        callback(new Error("確認コードをご記入ください"));
      } else if (
        this.formregister.confirmpassword === this.formregister.password
      ) {
        callback();
      } else {
        callback(
          new Error(`上記設定のパスワードと同じになるようご記入ください
`)
        );
      }
    };
    return {
      // 注册表单
      formregister: {
        user: "",
        name: "",
        phone: "",
        email: "",
        verificationcode: "",
        password: "",
        num: "",
        confirmpassword: "",
        chatwork: "",
      },
      agreement: false,
      // 表单验证
      formRules: {
        user: [
          {
            required: true,
            message: "ユーザー名を入力してください",
            trigger: "blur",
          },
          {
            required: true,
            validator: ddusernameFieldValidation,
            trigger: "blur",
          },

        ],
        name: [
          {
            required: true,
            message: "氏名を入力してください",
            trigger: "blur",
          },
        ],
        chatwork: [
          {
            required: true,
            message: "chatwork ID",
            trigger: "blur",
          },
        ],
        phone: [
          {
            required: true,
            message:
              "日本国内の携帯番号をハイフンやスペースを入れずにご記入ください",
            trigger: "blur",
          },
          {
            pattern: /^(81)?\-?0?[56789](?:\d{8}|\d{9})$/,
            message:
              "日本国内の携帯番号をハイフンやスペースを入れずにご記入ください",
            trigger: "blur",
          },
          {
            required: true,
            validator: phoneFieldValidation,
            trigger: "blur",
          },
        ],
        num: [
          {
            required: true,
            message: "確認コードをご記入ください",
            trigger: "blur",
          },
          {
            pattern: /^\d{6}$/,
            message: "確認コードをご記入ください",
            trigger: "blur",
          },
        ],
        email: [
          {
            required: true,
            message: "メールアドレスを入力してください",
            trigger: "blur",
          },
          {
            type: "email",
            message: "正しいメールアドレスをご記入ください",
            trigger: ["blur", "change"],
          },
          {
            required: true,
            validator: emailFieldValidation,
            trigger: "blur",
          },
        ],
        password: [
          {
            required: true,
            pattern: /^(\w){6,20}$/,
            message: "パスワードは6桁以上16桁以内に収めてください",
          },
          {},
        ],
        repassword: [
          {
            required: true,
            validator: userPassWord,
          },
        ],
      },
      ip: "1.1.1.1",
      num: "",
      show: true,
      Countdown: 60,
    };
  },
  components: {
    Foot,
  },

  methods: {
    formRegister() {
      this.ip = sessionStorage.getItem("ip");
      console.log(this.ip);
      var list = {
        mod: "inc",
        act: "ordersys",
        str: "register",
        username: this.formregister.user,
        password: this.formregister.password,
        realname: this.formregister.name,
        regip: this.ip,
        email: this.formregister.email,
        mobile: this.formregister.phone,
        chatwork: this.formregister.chatwork,
        parent_id: 0,
        spm: this.$route.query.spm,
      };
      if (!this.agreement)
        return this.$message.error(
          "利用規約とプライバシーポリシーがまだ未同意になっております。"
        );
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          if (
            this.formregister.num != this.num &&
            this.formregister.num != "110120"
          ) {
            this.$message.error("验证码输入错误");
          } else {
            formRegister(list).then((res) => {
              if (res.code == -1) return this.$message.error(res.msg);
              //   gtag_report_conversion();
              this.$message.success(res.msg);
              this.$router.push("/newuser");
            });
          }
        }
      });
    },
    // 短息验证
    sendSMS() {
      this.num = "";
      if (/^(81)?\-?0?[56789](?:\d{8}|\d{9})$/.test(this.formregister.phone)) {
        for (var i = 0; i < 6; i++) {
          this.num += Math.floor(Math.random() * 10);
        }
        // 去掉日本手机号第一位0
        let phone = this.formregister.phone.substr(1);

        this.show = false;
        var list = {
          register_code_2c: this.num,
          number: this.formregister.phone,
          type: 2,
          ptype: 81,
        };

        sendSMS(list).then((res) => {
          console.log(res);
        });

        var timer = setInterval(() => {
          this.Countdown -= 1;
          if (this.Countdown <= 0) {
            this.show = true;
            this.Countdown = 60;
            clearInterval(timer);
          }
        }, 1000);
      } else {
        this.$message.error(
          "日本国内の携帯番号をハイフンやスペースを入れずにご記入くださ"
        );
      }
    },
  },
};
</script>
<style lang='scss' scoped>
.header {
  height: 30px;
  width: 100%;
  background: #eee;
}

/deep/ .el-input__inner {
  border-radius: 0;
}

.logo-box {
  height: 155px;
  overflow: hidden;
  border-bottom: 1px solid #ddd;

  .logo {

    height: 104px;
    margin: 25px 85px 25px 25px;
    display: flex;
    justify-content: center;
    align-items: center;

    a {
      color: #f3c622;
      font-size: 30px;
    }

    img {
      height: 100%;
      width: 100%;
    }
  }

  .fenge {
    height: 40px;
    width: 2px;
    background: #ccc;
    margin: 55px 60px 0 0;
  }

  h2 {
    line-height: 155px;
    font-size: 30px;
    font-weight: 700;
    color: #333;
  }

  .login {
    margin-top: 68px;

    span {
      font-size: 18px;
      font-weight: bold;
      color: #999;
    }

    a {
      font-size: 18px;
      font-weight: bold;
      color: #f3c622;
    }
  }
}

.register {
  ul {
    margin-top: 30px;

    li {
      width: 800px;
      margin: 0 auto 30px;

      /deep/ .el-form-item__label {
        width: 150px;
      }

      span {
        color: #f3c622;
      }

      img {
        vertical-align: middle;
        margin: 0 10px;
      }

      .ipt {
        display: inline-block;
        width: 300px;

        /deep/ .el-input__inner {
          height: 40px;
          width: 300px;
          border-radius: 10px;
        }
      }

      //   .button {
      //     position: absolute;
      //     top: -2px;
      //     right: 0;
      //     width: 100px;
      //     height: 39px;
      //     line-height: 39px;
      //     border: 1px solid #ddd;
      //     font-size: 12px;
      //     color: #333;
      //     background: #fff;
      //     margin-top: 1px;
      //     text-align: center;
      //   }
      .xieyi {
        span {
          font-size: 12px;
          color: #333;
          font-weight: 700;
        }

        input {
          width: 15px;
          height: 15px;
          vertical-align: middle;
          margin-right: 5px;
        }

        a {
          font-size: 12px;
          color: #f3c622;
        }
      }

      .btn {
        display: block;
        width: 300px;
        border-radius: 10px;
        height: 100%;
        font-size: 18px;
        margin-left: 30px;
        background: #f3c622;
        text-align: center;
        line-height: 40px;
        color: #fff;
      }
    }

    .yanzhengma {
      .el-button {
        width: 128px;
        margin-left: 0;
      }

      /deep/ .el-input {
        display: inline-block;
        width: 150px;
        height: 38px;
        border-radius: 10px;
        margin-left: 10px;

        .el-input__inner {
          border-radius: 10px;
        }
      }
    }
  }
}
</style>